import { FormMode } from '../../../../types/formMode';
import Drawer from '@mui/material/Drawer';
import { makeStyles } from '@mui/styles';
import { useAppSelector } from '../../../../store/hooks';
import { selectSelectedSchema } from '../../../../store/schemas/schemasSelector';
import Alert from '@mui/material/Alert';
import { VersionableId } from '../../../../types/versionableId';
import SmscAddFormContainer from './SmscAddFormContainer';
import SmscEditFormContainer from './SmscEditFormContainer';
import SmscViewFormContainer from './SmscViewFormContainer';

const useStyles = makeStyles({
  drawerPaper: {
    width: '60%',
  },
});

const UndefinedSchemaAlert = () => (
  <Alert severity='error'>Error: Cannot open form due to schema is undefined!</Alert>
);

const UndefinedSmscIdAlert = () => (
  <Alert severity='error'>Error: Cannot open form due to smscId is undefined!</Alert>
);

const SmscFormContainer = (props: {
  readonly isOpen: boolean;
  readonly formMode: FormMode;
  readonly smscId?: VersionableId;
  readonly hideSmscForm: () => void;
}) => {
  const {
    isOpen,
    formMode,
    smscId,
    hideSmscForm,
  } = props;

  const classes = useStyles();
  const selectedSchema = useAppSelector(selectSelectedSchema);

  const renderAddingSmscForm = () => {
    if (!selectedSchema) {
      return <UndefinedSchemaAlert />;
    }

    return (
      <SmscAddFormContainer
        schema={selectedSchema}
        hideSmscForm={hideSmscForm}
      />
    );
  };

  const renderViewingSmscForm = () => {
    if (!smscId) {
      return <UndefinedSmscIdAlert />;
    }

    return (
      <SmscViewFormContainer
        smscId={smscId}
        hideSmscForm={hideSmscForm}
      />
    );
  };

  const renderEditingSmscForm = () => {
    if (!selectedSchema) {
      return <UndefinedSchemaAlert />;
    }
    if (!smscId) {
      return <UndefinedSmscIdAlert />;
    }

    return (
      <SmscEditFormContainer
        schema={selectedSchema}
        smscId={smscId}
        hideSmscForm={hideSmscForm}
      />
    );
  };

  const renderForm = {
    [FormMode.ADD]: renderAddingSmscForm,
    [FormMode.VIEW]: renderViewingSmscForm,
    [FormMode.EDIT]: renderEditingSmscForm,
  }[formMode];

  return (
    <Drawer
      anchor='right'
      open={isOpen}
      onClose={hideSmscForm}
      classes={{ paper: classes.drawerPaper }}
    >
      { renderForm() }
    </Drawer>
  );
};

export default SmscFormContainer;
